import Cookies from 'js-cookie';

class ModalMessage {
    constructor() {
        this.allAnchors = document.querySelectorAll('a.links.experience-modal-message,.modal__dialog a.button--close');
        this.allAnchors.forEach(link => link.addEventListener('click', this.handleLink.bind(this), false));

        this.allModalMessages = document.querySelectorAll('.modal-ek.message');
        this.allModalMessages.forEach(modal => document.querySelector('body').appendChild(modal));

        this.allNeedLogin = document.querySelectorAll('.needs-login');
        this.allNeedLogin.forEach( element => this.handleLogin( element ) );
    }

    handleLink(event) {
      event.stopPropagation();
      event.preventDefault();
    }

    handleLogin( element ) {
      let controlled_domains = ['design.bbvaexperience.com', 'kaghs10c.openweb.bbva', 'd1zx188tqaw0kd.cloudfront.net', 'revision-kaghs10c.openweb.bbva', 'revision-j95bw15y.openweb.bbva'];
      if( controlled_domains.includes(window.location.host) && undefined == Cookies.get('CloudFront-Key-Pair-Id') ) {
        element.remove();
      }
    }
}

export default ModalMessage;
